(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ac-product-details-static"] && !Shopify.designMode) return;
  try {
    (() => {
    const productFormComponents = document.querySelectorAll('product-form-component[id^="ac-product-form-component-"]');
    if (!productFormComponents.length) return;

    productFormComponents.forEach((productFormComponent) => {
      if (productFormComponent.dataset.acStaticInit === 'true') return;
      productFormComponent.dataset.acStaticInit = 'true';

      const variantInput = productFormComponent.querySelector('[ref="variantId"]');
      const staticRoot = productFormComponent.closest('.ac-product-details-static');
      const variantRadios = staticRoot ? Array.from(staticRoot.querySelectorAll('[data-variant-radio]')) : [];
      const quantityInput = productFormComponent.querySelector('[data-quantity-input]');
      const addToCartButton = productFormComponent.querySelector('[ref="addToCartButton"]');
      const addToCartDot = addToCartButton?.querySelector('.active-dott');
      const aboutToggle = staticRoot?.querySelector('[data-about-toggle]');
      const aboutDescription = staticRoot?.querySelector('.ac-product-details-static__description');

      const validateInventory = () => {
        if (!quantityInput) return true;

        const qty = Number(quantityInput.value || '0');
        if (!Number.isFinite(qty) || qty < 1) {
          quantityInput.setCustomValidity('Quantity must be at least 1.');
          return false;
        }

        const selectedRadio = variantRadios.find((radio) => radio.checked);
        const source = selectedRadio || quantityInput;
        const isManaged = source.dataset.inventoryManaged === 'true';
        const inventoryPolicy = source.dataset.inventoryPolicy || '';
        const inventoryQty = Number(source.dataset.inventoryQty || '0');

        if (isManaged && inventoryPolicy != 'continue' && qty > inventoryQty) {
          quantityInput.setCustomValidity(`Only ${inventoryQty} in stock.`);
          return false;
        }

        quantityInput.setCustomValidity('');
        return true;
      };

      if (variantInput && variantRadios.length) {
        const syncVariant = () => {
          const selectedRadio = variantRadios.find((radio) => radio.checked);
          if (!selectedRadio) return;
          variantInput.value = selectedRadio.value;
          if (addToCartButton) {
            addToCartButton.disabled = selectedRadio.disabled;
          }
          if (quantityInput) {
            quantityInput.dataset.inventoryQty = selectedRadio.dataset.inventoryQty || '0';
            quantityInput.dataset.inventoryManaged = selectedRadio.dataset.inventoryManaged || 'false';
            quantityInput.dataset.inventoryPolicy = selectedRadio.dataset.inventoryPolicy || '';
          }
          validateInventory();
        };

        syncVariant();
        variantRadios.forEach((radio) => radio.addEventListener('change', syncVariant));
      }

      if (quantityInput) {
        quantityInput.addEventListener('input', validateInventory);
        quantityInput.addEventListener('change', validateInventory);
      }

      productFormComponent.addEventListener('submit', (event) => {
        if (!validateInventory()) {
          event.preventDefault();
          event.stopPropagation();
          if (quantityInput) {
            quantityInput.reportValidity();
          }
        }
      });

      if (addToCartButton && addToCartDot) {
        const triggerDotBlink = () => {
          addToCartDot.classList.remove('is-blinking');
          // Restart animation when clicking repeatedly.
          void addToCartDot.offsetWidth;
          addToCartDot.classList.add('is-blinking');
        };

        // Pointer down feels more immediate than waiting for click.
        addToCartButton.addEventListener('pointerdown', triggerDotBlink, { passive: true });
        // Keep keyboard activation support (Enter/Space => click).
        addToCartButton.addEventListener('click', triggerDotBlink);
      }

      if (aboutToggle && aboutDescription) {
        const aboutLabel = aboutToggle.dataset.aboutLabel || 'About the artist';
        aboutToggle.addEventListener('click', () => {
          const isOpen = aboutDescription.classList.toggle('is-open');
          aboutToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          aboutToggle.textContent = isOpen ? `${aboutLabel} –` : `${aboutLabel} +`;
        });
      }
    });

    if (window.__acStaticProductCartOpenBound) return;
    window.__acStaticProductCartOpenBound = true;

    document.addEventListener('cart:update', (event) => {
      const sourceId = event?.detail?.sourceId;
      const didError = event?.detail?.data?.didError;
      if (!sourceId || didError || !sourceId.startsWith('ac-product-form-component-')) return;

      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer?.hasAttribute('auto-open')) return;
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    (() => {
    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const checkoutButton = target.closest('.cart__checkout-button');
      if (!(checkoutButton instanceof HTMLButtonElement)) return;

      const dot = checkoutButton.querySelector('.ac-checkout-dot');
      if (!(dot instanceof HTMLElement)) return;

      dot.classList.remove('is-blinking');
      // Restart animation for repeated clicks.
      void dot.offsetWidth;
      dot.classList.add('is-blinking');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = 'media-gallery.media-gallery--carousel slideshow-component';

    const clampInitialSlide = (raw, slideCount) => {
      if (slideCount <= 0) return 0;
      const n = Number.isFinite(raw) ? Math.floor(raw) : 0;
      return Math.min(Math.max(n, 0), slideCount - 1);
    };

    /** Theme Slideshow updates aria from scroll/IO; that disagrees with stacked AC fades — use host initial-slide only. */
    const normalizeAriaState = (slideshow) => {
      const slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
      if (!slides.length) return;

      const parsed = Number.parseInt(slideshow.getAttribute('initial-slide') || '0', 10);
      const index = clampInitialSlide(parsed, slides.length);
      setActiveSlide(slideshow, index);
    };

    const setActiveSlide = (slideshow, activeIndex) => {
      const slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
      if (!slides.length) return;

      const wrappedIndex = ((activeIndex % slides.length) + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const isActive = index === wrappedIndex;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.style.pointerEvents = isActive ? 'auto' : 'none';
      });

      // AC fade mode intercepts clicks before slideshow-component runs; sync counter manually.
      const indexOneBased = String(wrappedIndex + 1);
      slideshow.querySelectorAll('.slideshow-controls__counter > span:first-of-type').forEach((el) => {
        el.textContent = indexOneBased;
      });
    };

    const bind = (slideshow) => {
      if (!(slideshow instanceof HTMLElement) || slideshow.dataset.acFadeBound === 'true') return;

      const slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
      if (!slides.length) return;

      if (slides.length <= 1) {
        slideshow.dataset.acFadeBound = 'true';
        slideshow.dataset.acSliderReady = 'true';
        return;
      }

      slideshow.dataset.acFadeBound = 'true';
      slideshow.dataset.acSliderReady = 'false';

      const parsedInitial = Number.parseInt(slideshow.getAttribute('initial-slide') || '0', 10);
      let index = clampInitialSlide(Number.isFinite(parsedInitial) ? parsedInitial : 0, slides.length);

      slideshow.addEventListener(
        'click',
        (event) => {
          const button = event.target instanceof Element ? event.target.closest('.slideshow-control') : null;
          const selectTarget = event.target instanceof Element ? event.target.closest('[on\\:click^="/select/"]') : null;

          if (button instanceof HTMLElement) {
            if (button.classList.contains('slideshow-control--previous')) {
              event.preventDefault();
              event.stopPropagation();
              index -= 1;
              setActiveSlide(slideshow, index);
              return;
            }

            if (button.classList.contains('slideshow-control--next')) {
              event.preventDefault();
              event.stopPropagation();
              index += 1;
              setActiveSlide(slideshow, index);
              return;
            }
          }

          if (selectTarget instanceof HTMLElement) {
            const action = selectTarget.getAttribute('on:click') || '';
            const selectedIndex = Number.parseInt(action.replace('/select/', ''), 10);
            if (!Number.isNaN(selectedIndex)) {
              event.preventDefault();
              event.stopPropagation();
              index = selectedIndex;
              setActiveSlide(slideshow, index);
            }
          }
        },
        true
      );

      const reveal = () => {
        normalizeAriaState(slideshow);
        slideshow.dataset.acSliderReady = 'true';
      };

      normalizeAriaState(slideshow);
      requestAnimationFrame(() => {
        normalizeAriaState(slideshow);
        requestAnimationFrame(reveal);
      });
    };

    const init = () => {
      document.querySelectorAll(selector).forEach(bind);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('variant:update', () => {
      requestAnimationFrame(() => init());
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["slideshow-arrows"] && !Shopify.designMode) return;
  try {
    (() => {
    const desktopHover = () =>
      window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches;
    const selector = 'slideshow-arrows .slideshow-control--previous, slideshow-arrows .slideshow-control--next';

    const reset = (host) => {
      host.style.removeProperty('--arrow-pointer-x');
      host.style.removeProperty('--arrow-pointer-y');
      host.removeAttribute('data-active-arrow');
    };

    document.addEventListener('pointermove', (event) => {
      const button = event.target instanceof Element ? event.target.closest(selector) : null;
      if (!(button instanceof HTMLElement)) return;
      const host = button.closest('slideshow-arrows');
      if (!(host instanceof HTMLElement)) return;
      if (!desktopHover()) {
        reset(host);
        return;
      }

      const rect = host.getBoundingClientRect();
      host.style.setProperty('--arrow-pointer-x', `${event.clientX - rect.left}px`);
      host.style.setProperty('--arrow-pointer-y', `${event.clientY - rect.top}px`);
      host.setAttribute(
        'data-active-arrow',
        button.classList.contains('slideshow-control--previous') ? 'previous' : 'next'
      );
    });

    document.addEventListener('pointerleave', (event) => {
      const button = event.target instanceof Element ? event.target.closest(selector) : null;
      const host = button?.closest('slideshow-arrows');
      if (host instanceof HTMLElement) reset(host);
    }, true);

    document.addEventListener('focusout', (event) => {
      const button = event.target instanceof Element ? event.target.closest(selector) : null;
      const host = button?.closest('slideshow-arrows');
      if (host instanceof HTMLElement) reset(host);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["slideshow-controls"] && !Shopify.designMode) return;
  try {
    (() => {
    const canUseDesktopHover = () =>
      window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches;

    const attachPointerTracking = (button) => {
      if (button.dataset.pointerTrackingBound === 'true') return;
      button.dataset.pointerTrackingBound = 'true';

      const reset = () => {
        button.style.removeProperty('--slideshow-pointer-x');
        button.style.removeProperty('--slideshow-pointer-y');
      };

      button.addEventListener('mousemove', (event) => {
        if (!canUseDesktopHover()) {
          reset();
          return;
        }

        const rect = button.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        button.style.setProperty('--slideshow-pointer-x', `${x}px`);
        button.style.setProperty('--slideshow-pointer-y', `${y}px`);
      });

      button.addEventListener('mouseleave', reset);
      button.addEventListener('blur', reset);
    };

    const init = () => {
      document
        .querySelectorAll('slideshow-controls[controls-on-media] .slideshow-control--previous, slideshow-controls[controls-on-media] .slideshow-control--next')
        .forEach(attachPointerTracking);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
